import React from "react";
import { FaMicrosoft, FaPlaystation, FaXbox } from "react-icons/fa";
import { FaMeta } from "react-icons/fa6";
import {
  SiAsus,
  SiAtari,
  SiHtc,
  SiHyperx,
  SiLogitech,
  SiNintendo,
  SiSamsung,
  SiSony,
  SiValve,
} from "react-icons/si";

const Brand = () => {
  const brands = [
    { id: 1, name: "PlayStation", icon: FaPlaystation },
    { id: 2, name: "Xbox", icon: FaXbox },
    { id: 3, name: "Nintendo", icon: SiNintendo },
    { id: 4, name: "Meta", icon: FaMeta },
    { id: 5, name: "Microsoft", icon: FaMicrosoft },
    { id: 6, name: "Sony", icon: SiSony },
    { id: 7, name: "Logitech", icon: SiLogitech },
    { id: 8, name: "Atari", icon: SiAtari },
    { id: 9, name: "Samsung", icon: SiSamsung },
    { id: 10, name: "Valve", icon: SiValve },
    { id: 11, name: "HTC", icon: SiHtc },
    { id: 12, name: "ASUS", icon: SiAsus },
    { id: 13, name: "HyperX", icon: SiHyperx },
  ];

  return (
    <section className="bg-black px-4 sm:px-6 md:px-8 py-10 md:py-14 w-full">
      {/* Header */}
      <div className="max-w-7xl mx-auto text-center mb-8">
        <h1 className="text-white font-semibold text-2xl sm:text-3xl capitalize">
          top gaming <span className="text-orange-500">Brands</span>
        </h1>
        <p className="text-gray-400 mt-2 text-sm sm:text-base">
          Browse popular gaming brands we stock.
        </p>
      </div>

      {/* Grid */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-3 sm:gap-4 md:gap-5">
          {brands.map((brand) => {
            const Icon = brand.icon;

            return (
              <button
                key={brand.id}
                type="button"
                className="
                  group w-full
                  flex flex-col items-center justify-center
                  gap-3
                  rounded-2xl
                  border border-gray-800
                  bg-black/40
                  px-3 py-4
                  text-gray-300
                  shadow-sm
                  transition
                  hover:-translate-y-1 hover:border-orange-500 hover:text-orange-500
                  focus:outline-none focus:ring-2 focus:ring-orange-500/50
                "
                aria-label={brand.name}
              >
                <span className="text-3xl sm:text-[30px] leading-none">
                  <Icon />
                </span>
                <span className="text-xs sm:text-sm font-semibold text-center line-clamp-1">
                  {brand.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Brand;
